package co.maytes.standupbot.dashboard.features.standupruns

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.feedback.Modal
import co.maytes.standupbot.dashboard.components.feedback.ModalSize
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.Textarea
import co.maytes.standupbot.shared.dto.standuprun.UserSectionDto
import co.maytes.standupbot.shared.template.SectionKey
import co.maytes.standupbot.shared.template.SectionsConfigDto
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
fun SectionEditModal(
    currentSection: UserSectionDto,
    layout: SectionsConfigDto = SectionsConfigDto.DEFAULT,
    saving: Boolean = false,
    onSave: (yesterday: String, today: String, blockers: String?) -> Unit,
    onDismiss: () -> Unit,
) {
    var yesterday by remember { mutableStateOf(currentSection.yesterday.orEmpty()) }
    var today by remember { mutableStateOf(currentSection.today.orEmpty()) }
    var blockers by remember { mutableStateOf(currentSection.blockers.orEmpty()) }

    val slots = layout.includedSlots()
    val requiredFilled =
        slots.all { slot ->
            when (slot.key) {
                SectionKey.YESTERDAY -> yesterday.isNotBlank()
                SectionKey.TODAY -> today.isNotBlank()
                SectionKey.BLOCKERS -> true
            }
        }

    val dirty = yesterday != currentSection.yesterday.orEmpty() ||
        today != currentSection.today.orEmpty() ||
        blockers != currentSection.blockers.orEmpty()

    DisposableEffect(dirty) {
        if (dirty) {
            val listener: (Event) -> Unit = { e ->
                e.preventDefault()
                e.asDynamic().returnValue = "You have unsaved changes."
                Unit
            }
            window.addEventListener("beforeunload", listener)
            onDispose { window.removeEventListener("beforeunload", listener) }
        } else {
            onDispose { }
        }
    }

    val dismiss: () -> Unit = {
        if (!dirty || window.confirm("Discard your edits?")) onDismiss()
    }

    Modal(
        onDismiss = dismiss,
        title = "Edit your standup",
        size = ModalSize.Md,
        submitting = saving,
        footer = {
            Button(
                label = "Cancel",
                variant = ButtonVariant.Ghost,
                enabled = !saving,
                onClick = dismiss,
            )
            Button(
                label = if (saving) "Saving…" else "Save",
                variant = ButtonVariant.Primary,
                enabled = !saving && requiredFilled,
                onClick = { onSave(yesterday, today, blockers.takeIf { it.isNotBlank() }) },
            )
        },
    ) {
        slots.forEach { slot ->
            when (slot.key) {
                SectionKey.YESTERDAY ->
                    Textarea(
                        value = yesterday,
                        onValueChange = { yesterday = it },
                        label = slot.label,
                        placeholder = "What did you ship or move forward?",
                        rows = 4,
                    )
                SectionKey.TODAY ->
                    Textarea(
                        value = today,
                        onValueChange = { today = it },
                        label = slot.label,
                        placeholder = "What's on today's plan?",
                        rows = 4,
                    )
                SectionKey.BLOCKERS ->
                    Textarea(
                        value = blockers,
                        onValueChange = { blockers = it },
                        label = "${slot.label} (optional)",
                        placeholder = "Anything holding you up?",
                        rows = 4,
                    )
            }
        }
    }
}
